/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ItemCostAnalysis_item$ref: FragmentReference;
declare export opaque type ItemCostAnalysis_item$fragmentType: ItemCostAnalysis_item$ref;
export type ItemCostAnalysis_item = {|
  +id: string,
  +name: string,
  +cost: ?number,
  +calculatedMachineCost: ?number,
  +calculatedMaterialCost: ?number,
  +totalCalculatedCost: ?number,
  +costHistory: $ReadOnlyArray<{|
    +calculatedMachineCost: ?number,
    +calculatedMaterialCost: ?number,
    +totalCalculatedCost: ?number,
    +targetCost: ?number,
    +snapshotDate: any,
  |}>,
  +childItems: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +itemNumber: string,
        +name: string,
        +cost: ?number,
        +totalCalculatedCost: ?number,
      |},
      +usageQty: ?number,
    |}>
  |},
  +$refType: ItemCostAnalysis_item$ref,
|};
export type ItemCostAnalysis_item$data = ItemCostAnalysis_item;
export type ItemCostAnalysis_item$key = {
  +$data?: ItemCostAnalysis_item$data,
  +$fragmentRefs: ItemCostAnalysis_item$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "calculatedMachineCost",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "calculatedMaterialCost",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCalculatedCost",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ItemCostAnalysis_item",
  "type": "Item",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "childItems"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "costHistory",
      "storageKey": "costHistory(daysBack:90)",
      "args": [
        {
          "kind": "Literal",
          "name": "daysBack",
          "value": 90
        }
      ],
      "concreteType": "ItemCostHistory",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "targetCost",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "snapshotDate",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "childItems",
      "name": "__ItemCostAnalysis_childItems_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemChildConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemChildEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "itemNumber",
                  "args": null,
                  "storageKey": null
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v5/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "usageQty",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd3428cb381467dea1242f96a6719b806';
module.exports = node;
